import styled from 'styled-components';

export const SelectionButtonWrapper = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: top;
  list-style-type: none;
  padding: 0;
  margin-left: 0 !important; // neccesary to override skbv styling
  margin-bottom: 0 !important; // neccesary to override skbv styling
  margin-block-end: 0;
`;

export const Option = styled.li`
  display: inline-flex;
  height: max-content;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: transparent;
  padding-left: 0 !important; // nessecary to override skbv styling
  margin-left: ${(props) => props.border ? `-7px ` : `0`};
  margin-right: ${(props) => props.border ? `13px ` : `20px`};

  .container-fluid ul & {
    margin-bottom: 0;
  }
  
  @media (min-width: 768px) {
    margin-left: ${(props) => props.border ? `-7px ` : `0`};
    margin-right: ${(props) => props.border ? `13px ` : `20px`};
  }
`;


export const SelectionButtonLabel = styled.label `
  display: none;
  cursor: ${(props) => props.disabled ? 'deault' : 'pointer' };

  @media (min-width: 768px) {
    display: block;
    color: ${(props) => props.disabled ? '#cccccc' : '#111111' };
    width: 55px;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    overflow-wrap: break-word;
  }
`;

export const BorderBox = styled.div`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: max-content;
  background-color: transparent;
  border: ${(props) => props.border ? `2px solid black` : `none`};
  padding: ${(props) => props.border ? `5px ` : `7px 0`};
`;

export const ColorButton = styled.button`
  display: flex;
  flex: 1;
  min-width: 40px;
  max-width: 40px;
  height: 44px;
  background: ${(props) => props.backgroundColor}; // needs to be background instead of background-color because optional color comes as an image
  border: none;
  opacity: ${(props) => props.disabled ? '0.3' : '1'};
  cursor: ${(props) => props.disabled ? 'deault' : 'pointer' };

  @media (min-width: 768px) {
    min-width: 55px;
    max-width: 55px;
    height: 45px;
  }
`;

export const ImageButton = styled.button`
  display: flex;
  flex: 1;
  width: 65px;
  height: 65px;
  border: none;
  background-color: transparent;
  background-image: url(${(props) => props.image});
  cursor: ${(props) => props.disabled ? 'deault' : 'pointer' };
`;
